import * as Yup from 'yup';
import { Attachment } from '../../../../shared/types/shared';
import { OrbitPreferredContactMethodEnum } from '../../../../shared/types/orbit';

export interface OrbitPqrInfoValues {
    country: string;
    department: string;
    city: string;
    caseType: string;
    detail: string;
    preferredContactMethod: string;
    attachments: Attachment[];
}

export const initialValues: OrbitPqrInfoValues = {
    country: '',
    department: '',
    city: '',
    caseType: '',
    detail: '',
    preferredContactMethod: OrbitPreferredContactMethodEnum.Email,
    attachments: [],
};

export const validationSchema = (colombiaCountryId: string) =>
    Yup.object({
        country: Yup.string().required('El país es obligatorio'),
        department: Yup.string().when('country', {
            is: colombiaCountryId,
            then: (schema) => schema.required('El departamento es obligatorio'),
            otherwise: (schema) => schema.notRequired(),
        }),
        city: Yup.string().when('country', {
            is: colombiaCountryId,
            then: (schema) => schema.required('La ciudad es obligatoria'),
            otherwise: (schema) => schema.notRequired(),
        }),
        caseType: Yup.string().required('El tipo de caso PQRS es obligatorio'),
        detail: Yup.string()
            .trim()
            .required('El detalle de PQR es obligatorio')
            .min(10, 'El detalle de PQR debe tener al menos 10 caracteres')
            .max(4500, 'El detalle debe tener 4500 caracteres como máximo'),
        preferredContactMethod: Yup.string().required(
            'El medio de respuesta es obligatorio'
        ),
        attachments: Yup.array(),
    });
